import { NgModule } from '@angular/core';

import { AlphaNumericOnlyDirective } from './alpha-numeric-only.directive';
import { AutocompleteTabSelectDirective } from './autocomplete-tab-select.directive';
import { ComponentControlFocusDirective } from './component-control-focus.directive';
import { DecimalInputFormatDirective } from './decimal-input-format.directive';
import { DisableControlDirective } from './disable-control.directive';
import { FocusDirective } from './focus.directive';
import { FormatDecimalDirective } from './format-decimal.directive';
import { FormControlElementRefDirective } from './form-control-element-ref.directive';
import { MatchHeightDirective } from './match-height.directive';
import { NgLetDirective } from './ng-let.directive';
import { NumbersOnlyDirective } from './numbers-only.directive';
import { NumbersOnlyAltDirective } from './numbers-only-alt.directive';
import { PreventDefaultDirective } from './prevent-default.directive';
import { SdIfEnvDirective } from './env-access.directive';
import { StopPropagationDirective } from './stop-propagation.directive';
@NgModule({
  declarations: [
    AlphaNumericOnlyDirective,
    AutocompleteTabSelectDirective,
    ComponentControlFocusDirective,
    DecimalInputFormatDirective,
    DisableControlDirective,
    FocusDirective,
    FormatDecimalDirective,
    FormControlElementRefDirective,
    MatchHeightDirective,
    NgLetDirective,
    NumbersOnlyDirective,
    NumbersOnlyAltDirective,
    PreventDefaultDirective,
    SdIfEnvDirective,
    StopPropagationDirective
  ],
  exports: [
    AlphaNumericOnlyDirective,
    AutocompleteTabSelectDirective,
    ComponentControlFocusDirective,
    DecimalInputFormatDirective,
    DisableControlDirective,
    FocusDirective,
    FormatDecimalDirective,
    FormControlElementRefDirective,
    MatchHeightDirective,
    NgLetDirective,
    NumbersOnlyDirective,
    NumbersOnlyAltDirective,
    PreventDefaultDirective,
    SdIfEnvDirective,
    StopPropagationDirective
  ]
})
export class SharedDirectivesModule {}
